import { MutateFn } from '@diritto/common/base/mutateFunction';
import { TrackerExtraInfo, TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { ContentNotiApi } from 'api/ApiHelper';
import { useTrackingState } from 'contexts/TrackingProvider';
import { contentNotiQueryKey } from 'queries/contentNoti/queryKey';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useAddNewEpisodeNotiMutation = (
  contentId: number,
  trackerExtraInfo: TrackerExtraInfo,
  callback: MutateFn,
) => {
  const { tracker } = useTrackingState();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: contentNotiQueryKey.noti(contentId),
    mutationFn: () => ContentNotiApi.addNewEpisodeNoti(contentId),
    onMutate: callback.onMutate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: contentNotiQueryKey.noti(contentId) });
      tracker.track(TrackingEventType.AddNewEpisodeNoti, { contentId, trackerExtraInfo });
    },
    onError: callback.onError,
  });
};
